import React from 'react';
import { OnboardingChecklistbyCoach } from '../../Model/CoachHistory';

// For coaches signed up before Aug 1st has only 2 onboarding checklist items to complete by coach
const TOTAL_ONBOARDING_TASKS_NEW_COACH = OnboardingChecklistbyCoach.length;
const TOTAL_ONBOARDING_TASKS_EXISTING_COACH = 2;

const initialValues = {
  TOTAL_ONBOARDING_TASKS_NEW_COACH,
  TOTAL_ONBOARDING_TASKS_EXISTING_COACH,
  // The number of new-coach checklist steps that apply to the coach in context (the first chat message step only
  // applies to recent accounts)
  newCoachTaskCount: TOTAL_ONBOARDING_TASKS_NEW_COACH,
};

const OnboardingCoachNotificationsContext = React.createContext(initialValues);

export default OnboardingCoachNotificationsContext;
export {
  initialValues,
  TOTAL_ONBOARDING_TASKS_NEW_COACH,
  TOTAL_ONBOARDING_TASKS_EXISTING_COACH,
};
